import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// 使用 vuex-persistedstate 插件来持久化部分状态到 localStorage
const vuexPersisted = new createPersistedState({
  storage: {
    getItem: (key) => {
      const value = localStorage.getItem(key)
      if (value && (key === 'userInfo' || key === 'transactionPageType')) {
        return JSON.parse(value) // 反序列化 userInfo 和 transactionPageType
      }
      return value
    },
    setItem: (key, value) => {
      if (key === 'userInfo' || key === 'transactionPageType') {
        localStorage.setItem(key, JSON.stringify(value)) // 序列化 userInfo 和 transactionPageType
      } else {
        localStorage.setItem(key, value)
      }
    },
    removeItem: (key) => localStorage.removeItem(key),
  },
  paths: ['userInfo', 'isLogin', 'transactionPageType'], // 只持久化 userInfo, isLogin 和 transactionPageType
})

const store = new Vuex.Store({
  state: {
    userInfo: {},
    detail: [],
    order: {},
    isLogin: false,
    isDark: false,
    transactionPageType: 2, // 默认值
  },
  mutations: {
    login(state, provider) {
      state.userInfo = provider.loginSubscribersVO
      state.isLogin = true
      localStorage.setItem('userInfo', JSON.stringify(provider.loginSubscribersVO))
      localStorage.setItem('isLogin', true)
    },
    logout(state) {
      state.userInfo = {}
      state.isLogin = false
      localStorage.removeItem('userInfo')
      localStorage.removeItem('isLogin')
    },
    checkTheme(state, provider) {
      state.isDark = provider
    },
    delDetail(state) {
      state.detail = []
    },
    getDetail(state, provider) {
      state.detail.push(provider)
    },
    addOrder(state, provider) {
      state.order = provider
    },
    delOrder(state) {
      state.order = {}
    },
    // 设置交易页面类型
    setTransactionPageType(state, type) {
      state.transactionPageType = type
      localStorage.setItem('transactionPageType', JSON.stringify(type)) // 持久化到 localStorage
    },
  },
  actions: {},
  plugins: [vuexPersisted],
})

export default store
